import * as _ from "lodash";

// A catalog with only one or two categories gains nothing from a category
// selector, so the catalog hides it and gives its space to the products.
// `categories` is the list the page already filtered for this customer, i.e.
// exactly what the selector would render. Anything uncertain keeps the selector.
export function shouldHideCategorySelector(
  categories: any,
  hyperCategories: any,
  storeInfo: any,
  groupApp: any
): boolean {
  // Hyper-category stores (the selector also switches the hyper category) and
  // an unknown catalog, store or group keep the selector.
  if (
    !_.isArray(hyperCategories) ||
    hyperCategories.length !== 0 ||
    !_.isArray(categories) ||
    !storeInfo ||
    !groupApp
  ) {
    return false;
  }

  // Favorites-only catalogs: the count would follow each customer's favorites.
  if (storeInfo.showOnlyFavoritesCatalog) {
    return false;
  }

  // The beat header logo hangs below the toolbar: without the category bar
  // under it, it would cover the top of the product list.
  if (
    groupApp &&
    groupApp.beatMenuHeaderLogo &&
    groupApp.design_settings &&
    groupApp.design_settings.beatCatalogHeader &&
    groupApp.design_settings.enableMenuHeaderLogos
  ) {
    return false;
  }

  // The desktop category animation is drawn under the selector column.
  if (
    _.some(
      categories,
      (category) =>
        category &&
        _.find(category.catalogCategoryAnimationImages, {
          position: "browserLeft",
        })
    )
  ) {
    return false;
  }

  // With only the selected category shown, the selector is the only way to
  // reach a second category.
  const maxCategories =
    storeInfo.design_settings &&
    storeInfo.design_settings.showOnlySelectedCategoryProducts
      ? 1
      : 2;

  const categoriesCount = _.filter(
    categories,
    (category) => category && category.activeTotal
  ).length;

  return categoriesCount >= 1 && categoriesCount <= maxCategories;
}
